import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import './ResetButton.css'

class ResetButton extends Component {
  constructor(props) {
    super(props)

    this.resetAppState = this.resetAppState.bind(this)
  }

  getThemeWrapper(){
    return styled.div`
      .font-primary-color { color: ${props => props.theme.main}; }
    `
  }

  resetAppState(e) {
    e.preventDefault()
    const { dispatch } = this.props
    dispatch({ type: 'RESET' })
    return false
  }

  render() {
    const ThemeWrapper = this.getThemeWrapper()
    return (
      <ThemeWrapper>
        <a href="#reset" className="reset-button fa fa-undo font-primary-color" onClick={this.resetAppState}><span>Restart</span></a>
      </ThemeWrapper>
    )
  }
}

export default connect()(ResetButton)
